<template>
  <section id="admin-filter">
    <h4>Location filter</h4>
    <div class="form-group">
      <label for="filter-location-code" class="form-label">Code</label>
      <input type="text" class="form-control" id="filter-location-code" v-model="entity.code"/>
    </div>
    <div class="form-group">
      <label for="filter-location-name" class="form-label">Name</label>
      <input type="text" class="form-control" id="filter-location-name" v-model="entity.name"/>
    </div>
    <div class="form-group">
      <label for="filter-location-state" class="form-label">State</label>
      <input type="text" class="form-control" id="filter-location-state" v-model="entity.subdivision"/>
    </div>
    <div class="form-group">
      <label for="location-country" class="form-label">Country</label>
        <select class="form-control" id="location-country" v-model="entity.country">
          <option value=""></option>
          <option v-for="(opt, i) in countries" :value="opt.id">{{ opt.name }}</option>
        </select>
    </div>
    <div class="text-center">
      <div class="btn btn-primary sq"  @click="emitSearch">
        Search
      </div>
      <div class="btn btn-danger sq"  @click="close">
        Cancel
      </div>
    </div>
  </section>
</template>
<script>
  import FilterMixin from '../../mixins/FilterMixin'
  export default {
    name: 'LocationFilter',
    mixins: [ FilterMixin ],
    data () {
      return {
        entity: {
          name: '',
          code: '',
          subdivision: '',
          country: null
        }
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// LocationFilter.vue?ea4fa37a